import { Box, Container, Link } from '@mui/material';
import { useState } from 'react';
import type React from 'react';
import DisclaimerModal from './DisclaimerModal';

const linkStyles = {
  color: '#003781',
  textDecoration: 'none',
  fontWeight: 600,
  '&:hover': { textDecoration: 'underline' },
};

const PreFooterLinks: React.FC = () => {
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);

  return (
    <>
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderTop: '1px solid #e0e0e0',
        py: 2,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 4,
            flexWrap: 'wrap',
          }}
        >
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setDisclaimerOpen(true);
            }}
            sx={{ ...linkStyles, cursor: 'pointer' }}
          >
            Disclaimer and Important Information
          </Link>
          <Link
            href="https://www.allianzretireplus.com.au/contact.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={linkStyles}
          >
            Contact Us
          </Link>
        </Box>
      </Container>
    </Box>
    <DisclaimerModal open={disclaimerOpen} onClose={() => setDisclaimerOpen(false)} />
    </>
  );
};

export default PreFooterLinks;
